// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ag-theme-material .ag-row-odd {\n  background-color: #fafafa;\n}\n\n.ag-theme-material .ag-has-focus .ag-row-focus {\n  background-color: #f2f2f2;\n}", ""]);
// Exports
module.exports = exports;
